// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/certificate/fonts/MYRIADPRO-REGULAR.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/certificate/fonts/MYRIADPRO-BOLD.OTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/certificate/fonts/Myriad Pro Italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-output-preview-sheet {
  position: relative;
  width: 794px;
  min-height: 1123px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.16);
  border-radius: 10px;
  overflow: hidden;
}

.audit-output-preview-logo {
  position: absolute;
  object-fit: contain;
  z-index: 2;
}

.audit-output-preview-logo.is-editable {
  cursor: grab;
  outline: 2px dashed rgba(15, 118, 110, 0.35);
  border-radius: 8px;
}

.audit-output-preview-header,
.audit-output-preview-footer {
  display: flex;
  gap: 12px;
  z-index: 1;
}

.audit-output-preview-header {
  flex-direction: column;
}

.audit-output-preview-header.is-center {
  align-items: center;
  text-align: center;
}

.audit-output-preview-header.is-left {
  align-items: flex-start;
  text-align: left;
}

.audit-output-preview-header h2,
.audit-output-preview-header p,
.audit-output-preview-body p,
.audit-output-preview-body h3 {
  margin: 0;
}

.audit-output-preview-title {
  font-size: 2.4rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.16em;
  line-height: 1.05;
}

.audit-output-preview-subtitle {
  text-align: center;
  color: #0f172a;
  text-transform: none;
  letter-spacing: 0.18em;
  font-size: 0.9rem;
  margin-top: -4px;
}

.audit-output-preview-statement {
  text-align: center;
  color: #0f172a;
  font-style: italic;
  font-size: 0.95rem;
  margin-top: 8px;
}

.audit-output-preview-body {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1;
  z-index: 1;
}

.audit-output-preview-body.is-coordinate-layout {
  min-height: calc(100% - 120px);
}

.audit-output-coordinate-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 3;
}

.audit-output-coordinate-field {
  position: absolute;
  border: 1px dashed rgba(15, 118, 110, 0.55);
  background: rgba(255, 255, 255, 0.68);
  color: #0f172a;
  white-space: pre-line;
  overflow: hidden;
  padding: 2px 4px;
  line-height: 1.25;
}

.audit-output-preview-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.audit-output-preview-section label {
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  font-weight: 700;
}

.audit-output-preview-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.audit-output-preview-meta-card {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 12px 14px;
  background: rgba(15, 118, 110, 0.06);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.audit-output-preview-meta-card span {
  font-size: 0.76rem;
  color: #0f766e;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
}

.audit-output-preview-dates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.audit-output-preview-date-card {
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: rgba(255, 255, 255, 0.72);
}

.audit-output-preview-date-card span {
  font-size: 0.76rem;
  color: #64748b;
}

.audit-output-preview-signature {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 16px;
  border-top: 1px solid #cbd5e1;
  width: 50%;
}

.audit-output-preview-signature-image {
  display: block;
  object-fit: contain;
  object-position: left bottom;
  max-width: 100%;
}

.audit-output-preview-remarks {
  border-radius: 10px;
  padding: 12px 14px;
  background: rgba(15, 118, 110, 0.08);
  color: #134e4a;
}

.audit-output-preview-site-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.audit-output-preview-site-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.72);
}

.audit-output-preview-footer {
  margin-top: auto;
  justify-content: space-between;
  border-top: 1px solid #cbd5e1;
  padding-top: 10px;
  font-size: 0.8rem;
  color: #475569;
}

@media (max-width: 1200px) {
  .audit-output-preview-sheet {
    width: 100%;
    min-height: 920px;
  }

  .audit-output-preview-meta {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ── Drag-and-drop coordinate editor ── */

.audit-output-coordinate-layer.is-editable {
  pointer-events: auto;
}

.audit-output-coordinate-field.is-draggable {
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  border: 1.5px dashed rgba(15, 118, 110, 0.6);
  background: rgba(255, 255, 255, 0.72);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.audit-output-coordinate-field.is-draggable:hover {
  border-color: #0f766e;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.18);
  z-index: 5;
}

.audit-output-coordinate-field.is-selected {
  border: 2px solid #0f766e !important;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.15);
  z-index: 6;
  background: rgba(240, 253, 250, 0.85);
}

.audit-output-coordinate-field-label {
  position: absolute;
  top: -1px;
  left: 2px;
  font-size: 9px;
  font-weight: 700;
  color: #0f766e;
  background: rgba(240, 253, 250, 0.92);
  padding: 0 3px;
  border-radius: 2px;
  line-height: 1.4;
  pointer-events: none;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.1s;
}

.audit-output-coordinate-field.is-draggable:hover .audit-output-coordinate-field-label,
.audit-output-coordinate-field.is-selected .audit-output-coordinate-field-label {
  opacity: 1;
}

.audit-output-coordinate-field-resize {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  cursor: se-resize;
  background: #0f766e;
  border-radius: 2px 0 0 0;
  opacity: 0;
  transition: opacity 0.1s;
  touch-action: none;
}

.audit-output-coordinate-field.is-draggable:hover .audit-output-coordinate-field-resize,
.audit-output-coordinate-field.is-selected .audit-output-coordinate-field-resize {
  opacity: 0.7;
}

.audit-output-coordinate-field-resize:hover {
  opacity: 1 !important;
}

/* Floating toolbar for selected field */
.audit-output-coord-toolbar {
  position: absolute;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 4px;
  background: #0f172a;
  color: #f1f5f9;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 11px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);
  pointer-events: auto;
  white-space: nowrap;
}

.audit-output-coord-toolbar-label {
  font-weight: 700;
  color: #94a3b8;
  font-size: 10px;
}

.audit-output-coord-toolbar-sep {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.18);
  margin: 0 2px;
}

.audit-output-coord-toolbar-size {
  min-width: 28px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.audit-output-coord-toolbar button {
  background: none;
  border: none;
  color: #e2e8f0;
  cursor: pointer;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
}

.audit-output-coord-toolbar button:hover,
.audit-output-coord-toolbar button.is-active {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}
@font-face {
  font-family: 'Myriad Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Myriad Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'Myriad Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 400;
  font-style: italic;
}

.audit-output-preview-sheet {
  font-family: 'Myriad Pro', Arial, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/AuditOutputTemplatePreview.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,0CAA0C;;AAE1C;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,+DAAgF;EAChF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAgF;EAChF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":[".audit-output-preview-sheet {\n  position: relative;\n  width: 794px;\n  min-height: 1123px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.16);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.audit-output-preview-logo {\n  position: absolute;\n  object-fit: contain;\n  z-index: 2;\n}\n\n.audit-output-preview-logo.is-editable {\n  cursor: grab;\n  outline: 2px dashed rgba(15, 118, 110, 0.35);\n  border-radius: 8px;\n}\n\n.audit-output-preview-header,\n.audit-output-preview-footer {\n  display: flex;\n  gap: 12px;\n  z-index: 1;\n}\n\n.audit-output-preview-header {\n  flex-direction: column;\n}\n\n.audit-output-preview-header.is-center {\n  align-items: center;\n  text-align: center;\n}\n\n.audit-output-preview-header.is-left {\n  align-items: flex-start;\n  text-align: left;\n}\n\n.audit-output-preview-header h2,\n.audit-output-preview-header p,\n.audit-output-preview-body p,\n.audit-output-preview-body h3 {\n  margin: 0;\n}\n\n.audit-output-preview-title {\n  font-size: 2.4rem;\n  font-weight: 700;\n  text-align: center;\n  letter-spacing: 0.16em;\n  line-height: 1.05;\n}\n\n.audit-output-preview-subtitle {\n  text-align: center;\n  color: #0f172a;\n  text-transform: none;\n  letter-spacing: 0.18em;\n  font-size: 0.9rem;\n  margin-top: -4px;\n}\n\n.audit-output-preview-statement {\n  text-align: center;\n  color: #0f172a;\n  font-style: italic;\n  font-size: 0.95rem;\n  margin-top: 8px;\n}\n\n.audit-output-preview-body {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex: 1;\n  z-index: 1;\n}\n\n.audit-output-preview-body.is-coordinate-layout {\n  min-height: calc(100% - 120px);\n}\n\n.audit-output-coordinate-layer {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 3;\n}\n\n.audit-output-coordinate-field {\n  position: absolute;\n  border: 1px dashed rgba(15, 118, 110, 0.55);\n  background: rgba(255, 255, 255, 0.68);\n  color: #0f172a;\n  white-space: pre-line;\n  overflow: hidden;\n  padding: 2px 4px;\n  line-height: 1.25;\n}\n\n.audit-output-preview-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.audit-output-preview-section label {\n  font-size: 0.76rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.audit-output-preview-meta {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.audit-output-preview-meta-card {\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  padding: 12px 14px;\n  background: rgba(15, 118, 110, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.audit-output-preview-meta-card span {\n  font-size: 0.76rem;\n  color: #0f766e;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n}\n\n.audit-output-preview-dates {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.audit-output-preview-date-card {\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.audit-output-preview-date-card span {\n  font-size: 0.76rem;\n  color: #64748b;\n}\n\n.audit-output-preview-signature {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-top: 16px;\n  border-top: 1px solid #cbd5e1;\n  width: 50%;\n}\n\n.audit-output-preview-signature-image {\n  display: block;\n  object-fit: contain;\n  object-position: left bottom;\n  max-width: 100%;\n}\n\n.audit-output-preview-remarks {\n  border-radius: 10px;\n  padding: 12px 14px;\n  background: rgba(15, 118, 110, 0.08);\n  color: #134e4a;\n}\n\n.audit-output-preview-site-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.audit-output-preview-site-card {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.audit-output-preview-footer {\n  margin-top: auto;\n  justify-content: space-between;\n  border-top: 1px solid #cbd5e1;\n  padding-top: 10px;\n  font-size: 0.8rem;\n  color: #475569;\n}\n\n@media (max-width: 1200px) {\n  .audit-output-preview-sheet {\n    width: 100%;\n    min-height: 920px;\n  }\n\n  .audit-output-preview-meta {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ── Drag-and-drop coordinate editor ── */\n\n.audit-output-coordinate-layer.is-editable {\n  pointer-events: auto;\n}\n\n.audit-output-coordinate-field.is-draggable {\n  cursor: move;\n  user-select: none;\n  touch-action: none;\n  border: 1.5px dashed rgba(15, 118, 110, 0.6);\n  background: rgba(255, 255, 255, 0.72);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.audit-output-coordinate-field.is-draggable:hover {\n  border-color: #0f766e;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.18);\n  z-index: 5;\n}\n\n.audit-output-coordinate-field.is-selected {\n  border: 2px solid #0f766e !important;\n  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.15);\n  z-index: 6;\n  background: rgba(240, 253, 250, 0.85);\n}\n\n.audit-output-coordinate-field-label {\n  position: absolute;\n  top: -1px;\n  left: 2px;\n  font-size: 9px;\n  font-weight: 700;\n  color: #0f766e;\n  background: rgba(240, 253, 250, 0.92);\n  padding: 0 3px;\n  border-radius: 2px;\n  line-height: 1.4;\n  pointer-events: none;\n  white-space: nowrap;\n  opacity: 0;\n  transition: opacity 0.1s;\n}\n\n.audit-output-coordinate-field.is-draggable:hover .audit-output-coordinate-field-label,\n.audit-output-coordinate-field.is-selected .audit-output-coordinate-field-label {\n  opacity: 1;\n}\n\n.audit-output-coordinate-field-resize {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 12px;\n  height: 12px;\n  cursor: se-resize;\n  background: #0f766e;\n  border-radius: 2px 0 0 0;\n  opacity: 0;\n  transition: opacity 0.1s;\n  touch-action: none;\n}\n\n.audit-output-coordinate-field.is-draggable:hover .audit-output-coordinate-field-resize,\n.audit-output-coordinate-field.is-selected .audit-output-coordinate-field-resize {\n  opacity: 0.7;\n}\n\n.audit-output-coordinate-field-resize:hover {\n  opacity: 1 !important;\n}\n\n/* Floating toolbar for selected field */\n.audit-output-coord-toolbar {\n  position: absolute;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #0f172a;\n  color: #f1f5f9;\n  border-radius: 8px;\n  padding: 4px 8px;\n  font-size: 11px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);\n  pointer-events: auto;\n  white-space: nowrap;\n}\n\n.audit-output-coord-toolbar-label {\n  font-weight: 700;\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.audit-output-coord-toolbar-sep {\n  width: 1px;\n  height: 16px;\n  background: rgba(255, 255, 255, 0.18);\n  margin: 0 2px;\n}\n\n.audit-output-coord-toolbar-size {\n  min-width: 28px;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.audit-output-coord-toolbar button {\n  background: none;\n  border: none;\n  color: #e2e8f0;\n  cursor: pointer;\n  padding: 2px 5px;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.audit-output-coord-toolbar button:hover,\n.audit-output-coord-toolbar button.is-active {\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n}\n@font-face {\n  font-family: 'Myriad Pro';\n  src: url('../assets/certificate/fonts/MYRIADPRO-REGULAR.OTF') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Myriad Pro';\n  src: url('../assets/certificate/fonts/MYRIADPRO-BOLD.OTF') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Myriad Pro';\n  src: url('../assets/certificate/fonts/Myriad Pro Italic.ttf') format('truetype');\n  font-weight: 400;\n  font-style: italic;\n}\n\n.audit-output-preview-sheet {\n  font-family: 'Myriad Pro', Arial, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
